<div fxLayout="column" fxFlexFill fxLayoutAlign="center center" class="login-page backgroundlogin bg-pattern">
  <div fxLayout="column" class="logincard">
    <form class="input-custom-all floating-input">
      <div class=" mat-elevation-z4">
        <div class="container-image">
          <div class="img-logo">
            <img src="assets/logo-white.png">
          </div>
        </div>
        <mat-card class="" style="border-radius: 16px !important;">
          <mat-card-title>
            <div class="container-image">
              <div class="icon-logo">
                <img src="assets/login-icon.png">
              </div>
            </div>
          </mat-card-title>
          <mat-card-content class="">
            <div>
              <div class="title-content">
                <label>User Login</label>
              </div>
            </div>
            <span *ngIf="showSpinner">
              <mat-spinner style="margin: 0; top: 50%; left: 40%;"></mat-spinner>
            </span>
            <form fxLayout="column" fxLayoutAlign="start stretch" [formGroup]="userForm" (ngSubmit)="login()"
              *ngIf="!showSpinner">
              <div class="username">
                <mat-form-field appearance="outline">
                  <mat-label>Username<span class="asterisk-star">*</span></mat-label>
                  <input type="email" id="email" class="input" placeholder="Please enter your agent code"
                    formControlName="username" matInput>
                  <mat-error *ngIf="f.username.errors?.required && f.username.touched">
                    Username can not be empty, please complete it!
                  </mat-error>
                  <mat-error *ngIf="formErrors.username">
                    {{ formErrors.username }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="password">
                <mat-form-field appearance="outline">
                  <mat-label>Password<span class="asterisk-star">*</span></mat-label>
                  <input [type]="hide ==  true ? 'password' : 'text'" id="password" class="input"
                    placeholder="please  enter your password" formControlName="password" matInput>
                  <div class="eye">
                    <!--show-->
                    <div class="button-click" *ngIf="hide == false">
                      <mat-icon class="eye-custom" (click)="hideEye()">{{hide ? 'visibility_off' : 'visibility'}}
                      </mat-icon>
                    </div>

                    <!--hide-->
                    <div class="button-click" *ngIf="hide">
                      <mat-icon class="eye-custom" (click)="hideEye()">{{hide ? 'visibility_off' : 'visibility'}}
                      </mat-icon>
                    </div>
                  </div>
                  <mat-error *ngIf="f.password.errors?.required && f.password.touched">
                    Password can not be empty, please complete it!
                  </mat-error>
                  <mat-error *ngIf="formErrors.password">
                    {{ formErrors.password }}
                  </mat-error>
                  <mat-error *ngIf="f.username.errors?.isIncorrect || f.password.errors?.isIncorrect">
                    Wrong username / passsword
                  </mat-error>
                </mat-form-field>

                <input type="hidden" formControlName="loginType">
              </div>

              <div class="mt-25">
                <button class="btn-full btn-primary" type="submit" [disabled]="!userForm.valid">
                  Login
                </button>
              </div>
              <!--new desain-->
              <div class="forgot-password mt-20">
                <p>
                  <a class="redirect" (click)="lupaPasswordModal()">Lupa Password?</a>
                </p>
              </div>

             <div class="text-center mt-20">
                  Siap merekrut agen baru? 
             </div>
             <div class="text-center forgot-password">
                <a class="redirect" (click)="onboardingBenefit()">Jadilah Bagian Dari CHUBB Life</a>
            </div>
              <!--old desain-->
              <!-- <div class="forgot-password">
                <p>
                  <a class="redirect" [routerLink]="['/sigup']">Forgot Password ?</a>
                </p>
              </div> -->
              <!-- <p>New on our platform? <a class="redirect" [routerLink]="['/sigup']">Register an account</a> </p> -->
            </form>
            <div *ngIf="isLogin" class="help is-danger">
              Wrong username / passsword
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </form>
  </div>
</div>
